import { render } from "./SubclassEffdtView.vue?vue&type=template&id=1e245797"
import script from "./SubclassEffdtView.vue?vue&type=script&lang=js"
export * from "./SubclassEffdtView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__